<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('compassion.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'main' }">{{ $t('compassion.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-nav pills fill>
          <b-nav-item :to="{ name: 'love-life-articles', params: { type: 'sutra' } }" active>護生文集</b-nav-item>
          <b-nav-item :to="{ name: 'love-life-resources', params: { type: 'calendar' } }">資源下載</b-nav-item>
        </b-nav>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-dropdown text="請選擇分類" class="m-2">
          <b-dropdown-item
            v-for="article_type in article_types"
            :to="{ name: 'love-life-articles', params: { type: article_type.key } }"
          >{{ article_type.label }}</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <sutra v-if="type == 'sutra'"></sutra>
    <master-teachings v-if="type == 'master-teachings'"></master-teachings>
    <stop-killing-and-release-animals
      v-if="type == 'stop-killing-and-release-animals'"
    ></stop-killing-and-release-animals>
    <vegetarian v-if="type == 'vegetarian'"></vegetarian>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { DropdownPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'

import MasterTeachings from '@/views/love-life/article/MasterTeachings'
import StopKillingAndReleaseAnimals from '@/views/love-life/article/StopKillingAndReleaseAnimals'
import Sutra from '@/views/love-life/article/Sutra'
import Vegetarian from '@/views/love-life/article/Vegetarian'
import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(DropdownPlugin)
Vue.use(NavPlugin)

export default {
  i18n,
  name: "articles",
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      article_types: [
        { key: 'sutra', label: '經典節錄'},
        { key: 'master-teachings', label: '宗師開示'},
        { key: 'stop-killing-and-release-animals', label: '戒殺放生文集'},
        { key: 'vegetarian', label: '素食文章'},
      ]
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    MasterTeachings,
    StopKillingAndReleaseAnimals,
    Sutra,
    Vegetarian
  },
  metaInfo() {
    return {
      title: this.$t('compassion.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>